import { motion, useReducedMotion } from "framer-motion";

const variants = {
  hidden: { opacity: 0, y: 16 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: i * 0.06 },
  }),
};

export function FadeUp({ children, delay = 0, className = "", as: As = "div", ...rest }) {
  const reduce = useReducedMotion();

  // Respect user preference — no animation, content visible immediately.
  if (reduce) {
    return (
      <div className={className} {...rest}>
        {children}
      </div>
    );
  }

  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      // amount: 0 → fires the moment any part of the element is in viewport
      // (critical for above-the-fold content like the hero — prevents the
      // observer from waiting until past the configured margin).
      viewport={{ once: true, amount: 0 }}
      variants={variants}
      custom={delay}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function Stagger({ children, className = "" }) {
  return <div className={className}>{children}</div>;
}
